import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/Auth";
import LayOut from "../../components/LayOut";
import axios from "axios";
import { FaPen } from "react-icons/fa";
import UpdateProfile from "./updateProfile"; // popup ke liye import
import "../Styles/userDashboard.css";

const UserDashBoard = () => {
  const [auth] = useAuth();
  const [user, setUser] = useState(null);
  const [showPopup, setShowPopup] = useState(false); // popup toggle

  const id = auth?.user?.id;

  // Move fetchUser outside useEffect for reuse
  const fetchUser = async () => {
    try {
      const response = await axios.get(
        `https://portfoliomern-mxue.onrender.com/api/v1/auth/users/${id}`
      );
      setUser(response.data);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  useEffect(() => {
    if (id) fetchUser();
  }, [id]);

  // Custom onClose handler for popup
  const handlePopupClose = () => {
    setShowPopup(false);
    fetchUser(); // refresh user data after popup closes
  };

  return (
    <LayOut title={"User Dashboard"}>
      <div
        className="d-flex flex-column flex-md-row"
        style={{ backgroundColor: "#000", color: "#fff", minHeight: "100vh" }}
      >
        {/* Sidebar */}
        <div
          className="bg-dark p-4"
          style={{ width: "100%", maxWidth: "250px", flexShrink: 0 }}
        >
          <div className="profile-section text-center mb-4">
            <div className="profile-photo-container">
              <img
                src={user?.image}
                alt="User Profile"
                className="profile-image"
              />
              <span className="edit-icon" onClick={() => setShowPopup(true)}>
                <FaPen />
              </span>
            </div>
            <div className="mt-3">
              <h4 className="text-light">{auth?.user?.name}</h4>
              <p className="text-white-50 mb-1">{auth?.user?.phone}</p>
              <p className="text-white-50">{auth?.user?.email}</p>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="p-4" style={{ flex: 1 }}>
          <h1 className="text-light">User Dashboard</h1>
          <p className="text-white-50">Welcome to your personal dashboard.</p>
        </div>
      </div>

      {/* Popup Modal */}
      {showPopup && <UpdateProfile onClose={handlePopupClose} />}
    </LayOut>
  );
};

export default UserDashBoard;
